/* SG · PDP v2 (sections/sg-pdp2-main.liquid, sg-pdp2-bag.liquid)
   - cambio variante: aggiorna id, URL, bottoni, foto; poi chiede la sezione renderizzata con
     ?variant=ID&section_id=... e sostituisce i nodi [data-sgx-swap] (prezzo, avvisi, metafield variante)
   - sezioni collegate ([data-sgx-vsec], es. contenuto bag) si ricaricano sull'evento sg:variant-change
   - carrello: POST /cart/add.js; il drawer del tema (assets/sg-upcart.js) intercetta la richiesta e si apre da solo.
     Con il vecchio tema si apre UpCart (upcartRefreshCart / upcartOpenCart); senza nessuno dei due -> /cart
   - consegna: dati del metaobject sg_shipping (data-*), calcolo nel fuso Europe/Rome
   - soglie spedizione/sconto dalla config del drawer (#sg-upcart-config, setting del tema), convertite nella
     valuta del mercato; in mancanza da UpCart (upcartGetRewards). Barra premi come il drawer: spedizione sul totale
     dopo gli sconti, sconto automatico sul subtotale prima degli sconti */
(function () {
  'use strict';

  var lang = document.documentElement.lang || 'it';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(lang, { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  /* Soglie della barra premi (una sola lettura per pagina). Importi in euro -> valuta del mercato attivo */
  var rate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
  function cfgTiers() {
    var el = document.getElementById('sg-upcart-config');
    if (!el) return null;
    var cfg;
    try { cfg = JSON.parse(el.textContent); } catch (e) { return null; }
    /* clienti B2B: niente barra, come nel drawer */
    if (cfg.hideForB2b && cfg.b2b && !/[?&]sg_cart_show_all\b/.test(window.location.search)) return [];
    if (cfg.barEnabled === false) return [];
    return (cfg.tiers || []).filter(function (t) { return t && t.amount > 0; }).map(function (t) {
      return { minAmount: t.amount * rate, targetType: t.kind === 'shipping' ? 'shipping' : 'discount', rewardDescription: t.label || '' };
    }).sort(function (a, b) { return a.minAmount - b.minAmount; });
  }
  var tiersPromise = null;
  function getTiers() {
    if (tiersPromise) return tiersPromise;
    tiersPromise = new Promise(function (resolve) {
      var tries = 0;
      (function attempt() {
        var own = cfgTiers();
        if (own) { resolve(own); return; }
        if (typeof window.upcartGetRewards === 'function' && (window.__upcartInitialized || tries > 40)) {
          Promise.resolve(window.upcartGetRewards()).then(function (r) {
            var t = (r && r.tiers) || [];
            resolve(t.filter(function (x) { return x && x.minAmount > 0; }).map(function (x) {
              return { minAmount: x.minAmount * rate, targetType: x.targetType, rewardDescription: x.rewardDescription };
            }).sort(function (a, b) { return a.minAmount - b.minAmount; }));
          }, function () { resolve([]); });
        } else if (tries++ < 60) {
          setTimeout(attempt, 250);
        } else {
          resolve([]);
        }
      })();
    });
    return tiersPromise;
  }

  /* Stima di consegna */
  function romeNow() {
    var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Rome', hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
    var o = {};
    f.formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day, h: (+o.hour) % 24, mi: +o.minute };
  }
  function renderShip(el) {
    var cutoff = parseInt(el.dataset.cutoff, 10);
    if (isNaN(cutoff)) cutoff = 12;
    var minD = parseInt(el.dataset.min, 10) || 0;
    var maxD = parseInt(el.dataset.max, 10) || minD;
    var sat = el.dataset.sat === 'true';
    var closed = (el.dataset.closed || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var key = function (dt) { return dt.toISOString().slice(0, 10); };
    var isShipDay = function (dt) { var g = dt.getUTCDay(); if (g === 0 || (g === 6 && !sat)) return false; return closed.indexOf(key(dt)) < 0; };
    var isDelivDay = function (dt) { var g = dt.getUTCDay(); return g >= 1 && g <= 5 && closed.indexOf(key(dt)) < 0; };
    var addDeliv = function (dt, n) { var x = new Date(dt.getTime()); while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (isDelivDay(x)) n--; } return x; };
    var fmt = function (dt, o) { try { o.timeZone = 'UTC'; return dt.toLocaleDateString(lang, o); } catch (e) { return dt.getUTCDate() + '/' + (dt.getUTCMonth() + 1); } };

    var now = romeNow();
    var ship = new Date(Date.UTC(now.y, now.m - 1, now.d));
    var sameDay = isShipDay(ship) && now.h < cutoff;
    if (!sameDay) {
      var guard = 0;
      do { ship.setUTCDate(ship.getUTCDate() + 1); } while (!isShipDay(ship) && guard++ < 60);
    }
    var from = addDeliv(ship, minD);
    var to = addDeliv(ship, maxD);
    var time;
    if (sameDay) {
      var mins = (cutoff - now.h) * 60 - now.mi;
      var hh = Math.floor(mins / 60);
      time = (el.dataset.left || '{left}').replace('{left}', (hh > 0 ? hh + ' h ' : '') + (mins % 60) + ' min');
    } else {
      time = (el.dataset.at || '{day} {hour}')
        .replace('{day}', fmt(ship, { weekday: 'long' }))
        .replace('{hour}', (cutoff < 10 ? '0' : '') + cutoff + ':00');
    }
    var dOpt = { weekday: 'short', day: 'numeric', month: 'short' };
    var txt = esc(el.dataset.msg || '')
      .replace('{time}', '<strong>' + esc(time) + '</strong>')
      .replace('{from}', '<strong>' + esc(fmt(from, dOpt)) + '</strong>')
      .replace('{to}', '<strong>' + esc(fmt(to, dOpt)) + '</strong>');
    el.querySelector('[data-sgx-ship-text]').innerHTML = txt;
  }

  /* Gallery: traccia a scorrimento + miniature */
  function gallery(sec) {
    var track = sec.querySelector('[data-sgx-track]');
    if (!track) return function () {};
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = sec.querySelectorAll('[data-sgx-thumb]');
    var count = sec.querySelector('[data-sgx-count]');
    var total = sec.querySelector('[data-sgx-total]');
    /* le foto di altre varianti sono nascoste (hidden): indici e contatore contano solo quelle visibili */
    var vis = function () { return slides.filter(function (s) { return !s.hidden; }); };
    var idx = function () { return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; };
    var go = function (i, smooth) {
      i = Math.max(0, Math.min(vis().length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    };
    var mark = function () {
      var v = vis();
      var i = Math.min(idx(), v.length - 1);
      if (count) count.textContent = i + 1;
      var id = v[i] && v[i].getAttribute('data-sgx-media');
      Array.prototype.forEach.call(thumbs, function (t) { t.classList.toggle('is-active', t.getAttribute('data-sgx-thumb') === id); });
      slides.forEach(function (s) { if (s !== v[i]) { var vd = s.querySelector('video'); if (vd && !vd.paused) vd.pause(); } });
    };
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; mark(); });
    }, { passive: true });
    var prev = sec.querySelector('[data-sgx-prev]');
    var next = sec.querySelector('[data-sgx-next]');
    if (prev) prev.addEventListener('click', function () { go(idx() - 1, true); });
    if (next) next.addEventListener('click', function () { go(idx() + 1, true); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx() - 1, true); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx() + 1, true); }
    });
    Array.prototype.forEach.call(thumbs, function (t) {
      t.addEventListener('click', function () { goMedia(t.getAttribute('data-sgx-thumb')); });
    });
    function goMedia(mediaId) {
      if (!mediaId) return;
      var v = vis();
      for (var n = 0; n < v.length; n++) {
        if (v[n].getAttribute('data-sgx-media') === String(mediaId)) { go(n, true); return; }
      }
    }
    /* Foto per variante (etichette EComposer, vedi sg-pdp2-gallery): stessa regola del Liquid */
    goMedia.filter = function (variantId) {
      var key = ',' + variantId + ',';
      var items = slides.concat(Array.prototype.slice.call(sec.querySelectorAll('.sgx-gal__thumbs li[data-sgx-vars]')));
      var own = slides.some(function (s) { return (s.getAttribute('data-sgx-vars') || '').indexOf(key) > -1; });
      items.forEach(function (el) {
        var vars = el.getAttribute('data-sgx-vars') || '';
        el.hidden = own && vars !== '' && vars.indexOf(key) < 0;
      });
      if (total) total.textContent = vis().length;
      track.scrollTo({ left: 0, behavior: 'auto' });
      mark();
    };
    return goMedia;
  }

  function init(sec) {
    if (!sec || sec.dataset.sgxInit) return;
    sec.dataset.sgxInit = '1';

    var sectionId = sec.dataset.section;
    var url = sec.dataset.url;
    var form = sec.querySelector('[data-sgx-form]');
    var idInput = form && form.querySelector('[data-sgx-id]');
    var jsonEl = sec.querySelector('[data-sgx-json]');
    if (!form || !idInput || !jsonEl) return;
    var variants = [];
    try { variants = JSON.parse(jsonEl.textContent).variants || []; } catch (e) {}
    var find = function (id) { for (var i = 0; i < variants.length; i++) { if (variants[i].id === +id) return variants[i]; } return null; };
    var current = find(idInput.value) || { id: +idInput.value, available: true, price: '' };
    var tAdd = sec.dataset.tAdd || '';
    var tAddShort = sec.dataset.tAddShort || tAdd;
    var tSold = sec.dataset.tSold || '';
    var tError = sec.dataset.tError || '';
    var priceInButton = sec.dataset.priceInButton === 'true';
    var goMedia = gallery(sec);
    var barBtn = sec.querySelector('.sgx-bar__btn');
    var barLabel = barBtn ? barBtn.getAttribute('data-label') : '';

    function syncButtons() {
      sec.querySelectorAll('[data-sgx-atc]').forEach(function (b) {
        b.disabled = !current.available;
        if (!current.available) { b.textContent = tSold; return; }
        if (b.hasAttribute('data-sgx-main-atc')) {
          b.innerHTML = '<span class="sgx-atc__long">' + esc(tAdd) + '</span><span class="sgx-atc__short">' + esc(tAddShort) + '</span>' +
            (priceInButton && current.price ? '<span class="sgx-atc__price">' + esc(current.price) + '</span>' : '');
        } else {
          b.textContent = barLabel || tAdd;
        }
      });
      var bv = sec.querySelector('[data-sgx-bar-var]');
      if (bv && current.name) bv.textContent = current.name;
      sec.querySelectorAll('.sgx-ship-wrap').forEach(function (w) { w.hidden = !current.available; });
    }

    /* Sostituzione dei nodi che dipendono dalla variante */
    var ctrl = null;
    function refresh(id) {
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + id + '&section_id=' + sectionId, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          sec.querySelectorAll('[data-sgx-swap]').forEach(function (el) {
            var fresh = doc.querySelector('[data-sgx-swap="' + el.getAttribute('data-sgx-swap') + '"]');
            if (!fresh) return;
            var state = {};
            el.querySelectorAll('details[id]').forEach(function (d) { state[d.id] = d.open; });
            el.innerHTML = fresh.innerHTML;
            el.querySelectorAll('details[id]').forEach(function (d) { if (d.id in state) d.open = state[d.id]; });
          });
        })
        .catch(function () {});
    }

    function select(id) {
      var v = find(id);
      if (!v) return;
      current = v;
      idInput.value = v.id;
      syncButtons();
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState(window.history.state, '', u.toString());
      } catch (e) {}
      if (goMedia.filter) goMedia.filter(v.id);
      if (v.media) goMedia(v.media);
      refresh(v.id);
      document.dispatchEvent(new CustomEvent('sg:variant-change', { detail: { productId: sec.dataset.product, variantId: v.id, sectionId: sectionId } }));
    }

    sec.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute('data-sgx-variant')) select(e.target.value);
    });

    /* Caroselli (recensioni brevi, stessa linea): frecce su mobile, su desktop sono griglie */
    sec.querySelectorAll('[data-sgx-carousel]').forEach(function (box) {
      var list = box.querySelector('[data-sgx-carousel-list]');
      var btns = box.querySelectorAll('[data-sgx-cnav]');
      if (!list) return;
      var sync = function () {
        var max = list.scrollWidth - list.clientWidth - 2;
        btns.forEach(function (b) {
          b.disabled = b.getAttribute('data-sgx-cnav') === '-1' ? list.scrollLeft <= 2 : list.scrollLeft >= max;
        });
      };
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var card = list.firstElementChild;
          var step = card ? card.getBoundingClientRect().width + 10 : list.clientWidth;
          var from = list.scrollLeft;
          var to = Math.max(0, Math.min(list.scrollWidth - list.clientWidth, from + step * parseInt(b.getAttribute('data-sgx-cnav'), 10)));
          list.scrollTo({ left: to, behavior: 'smooth' });
          /* se lo scorrimento animato non parte (browser o scheda in background), si salta direttamente */
          setTimeout(function () {
            if (Math.abs(list.scrollLeft - from) < 2 && Math.abs(to - from) >= 2) list.scrollTo({ left: to, behavior: 'instant' });
            sync();
          }, 450);
        });
      });
      list.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      sync();
    });

    /* Quantita' */
    sec.addEventListener('click', function (e) {
      var step = e.target.closest('[data-sgx-step]');
      if (step) {
        var input = sec.querySelector('[data-sgx-qty]');
        if (!input) return;
        var n = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-sgx-step'), 10);
        input.value = Math.max(1, Math.min(99, n));
        return;
      }
      var opener = e.target.closest('[data-sgx-open]');
      if (opener) {
        var d = sec.querySelector('details[data-sgx-acc="' + opener.getAttribute('data-sgx-open') + '"]');
        if (d) { d.open = true; d.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      }
      var all = e.target.closest('[data-sgx-all]');
      if (all) {
        var ex = document.getElementById('sg-explore');
        if (!ex) return;
        e.preventDefault();
        var from = window.scrollY;
        var y = Math.max(0, Math.round(ex.getBoundingClientRect().top + from - headerBottom() - 12));
        window.scrollTo({ top: y, behavior: 'smooth' });
        /* come per i caroselli: se lo scorrimento animato non parte si salta direttamente */
        setTimeout(function () {
          if (Math.abs(window.scrollY - from) < 2 && Math.abs(y - from) >= 2) window.scrollTo({ top: y, behavior: 'instant' });
        }, 450);
      }
    });

    /* Carrello */
    var lastCartOpen = 0;
    var cartSub = false;
    function watchCart() {
      if (cartSub || typeof window.upcartSubscribeCartOpened !== 'function') return;
      cartSub = true;
      try { window.upcartSubscribeCartOpened(function () { lastCartOpen = Date.now(); }); } catch (x) {}
    }
    var errEl = sec.querySelector('[data-sgx-error]');
    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg || tError;
      errEl.hidden = false;
      /* dalla barra fissa il messaggio sarebbe fuori schermo */
      var r = errEl.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) errEl.scrollIntoView({ block: 'center' });
    }
    var adding = false;
    /* UpCart intercetta l'invio del form e aggiunge da solo: il doppio clic si ferma gia' sul clic */
    var lastAtc = 0;
    sec.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-sgx-atc]');
      if (!b) return;
      var now = Date.now();
      if (now - lastAtc < 1500) { e.preventDefault(); e.stopPropagation(); return; }
      lastAtc = now;
    }, true);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!current.available || adding) return;
      adding = true;
      watchCart();
      /* UpCart puo' aprirsi gia' mentre intercetta la richiesta: si confronta con l'ora del clic */
      var addedAt = Date.now();
      var btns = sec.querySelectorAll('[data-sgx-atc]');
      var fd = new FormData(form);
      if (!fd.get('quantity')) fd.set('quantity', '1');
      if (errEl) errEl.hidden = true;
      btns.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) { showError(res.j.description || res.j.message); return; }
          if (window.sgUpcart) {
            /* il drawer del tema ha gia' visto la richiesta a /cart/add.js e si apre da solo */
          } else if (typeof window.upcartRefreshCart === 'function') {
            /* UpCart di solito intercetta /cart/add.js e si apre da solo: lo forziamo solo se non e' successo */
            setTimeout(function () {
              if (lastCartOpen >= addedAt) return;
              try { window.upcartRefreshCart(); } catch (x) {}
              if (typeof window.upcartOpenCart === 'function') { try { window.upcartOpenCart(); } catch (x) {} }
            }, 900);
          } else {
            window.location.href = root + 'cart';
            return;
          }
          if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
            try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'sg-pdp2', productVariantId: current.id, cartData: res.j }); } catch (x) {}
          }
          document.dispatchEvent(new CustomEvent('sg:cart-add', { detail: res.j }));
        })
        .catch(function () { showError(tError); })
        .then(function () { adding = false; btns.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); }); });
    });

    /* Barra fissa: visibile quando il bottone principale non e' sullo schermo (dopo i primi 320 px) */
    var bar = sec.querySelector('[data-sgx-bar]');
    var mainAtc = sec.querySelector('[data-sgx-main-atc]');
    if (bar && mainAtc) {
      bar.hidden = false;
      var barTick = false;
      var evalBar = function () {
        barTick = false;
        var r = mainAtc.getBoundingClientRect();
        /* in fondo alla pagina si nasconde, cosi' non copre il footer */
        var atEnd = window.innerHeight + window.scrollY > document.documentElement.scrollHeight - 160;
        var show = !(r.bottom > 0 && r.top < window.innerHeight) && window.scrollY > 320 && !atEnd;
        bar.classList.toggle('is-visible', show);
        document.body.classList.toggle('sgx-bar-on', show);
      };
      window.addEventListener('scroll', function () {
        if (!barTick) { barTick = true; window.requestAnimationFrame(evalBar); }
      }, { passive: true });
      evalBar();
    }

    /* Buy box sticky su desktop: sotto l'header fisso; se e' piu' alta dello schermo scorre e si ferma in fondo */
    var info = sec.querySelector('.sgx-info');
    function headerBottom() {
      var el = document.elementFromPoint(window.innerWidth / 2, 2);
      while (el && el !== document.body && el !== document.documentElement) {
        var cs = window.getComputedStyle(el);
        if (cs.position === 'fixed' || cs.position === 'sticky') {
          var b = el.getBoundingClientRect().bottom;
          return b > 0 && b < 220 ? b : 0;
        }
        el = el.parentElement;
      }
      return 0;
    }
    function stickTop() {
      if (!info) return;
      var head = headerBottom();
      var h = info.offsetHeight;
      var vh = window.innerHeight;
      var top = h + head + 40 > vh ? Math.round(vh - h - 24) : Math.round(head + 16);
      info.style.setProperty('--sgx-top', top + 'px');
    }
    stickTop();
    window.addEventListener('resize', stickTop);
    window.addEventListener('load', stickTop);
    if ('ResizeObserver' in window && info) new ResizeObserver(stickTop).observe(info);

    /* Consegna */
    sec.querySelectorAll('[data-sgx-ship]').forEach(function (el) {
      renderShip(el);
      el.hidden = false;
      setInterval(function () { renderShip(el); }, 60000);
    });

    /* Soglie e barra premi (config del drawer del tema o UpCart) */
    var reward = sec.querySelector('[data-sgx-reward]');
    getTiers().then(function (tiers) {
      if (!tiers.length) return;
      var shipT = tiers.filter(function (t) { return t.targetType === 'shipping'; })[0];
      var discT = tiers.filter(function (t) { return t.targetType !== 'shipping'; })[0];
      var pctM = discT && String(discT.rewardDescription || '').match(/(\d+(?:[.,]\d+)?)\s*%/);
      var vals = {
        shipping: shipT ? money(Math.round(shipT.minAmount * 100)) : '',
        discount: discT ? money(Math.round(discT.minAmount * 100)) : '',
        pct: pctM ? pctM[1] + '%' : ''
      };
      sec.querySelectorAll('[data-sgx-tier]').forEach(function (s) { s.textContent = vals[s.getAttribute('data-sgx-tier')] || ''; });
      sec.querySelectorAll('[data-sgx-tier-row]').forEach(function (row) {
        row.hidden = !Array.prototype.every.call(row.querySelectorAll('[data-sgx-tier]'), function (s) { return s.textContent !== ''; });
      });
      if (!reward) return;
      var last = tiers[tiers.length - 1].minAmount * 100;
      var tick = reward.querySelector('[data-sgx-reward-tick]');
      if (shipT && shipT !== tiers[tiers.length - 1]) tick.style.left = (shipT.minAmount * 100 / last * 100) + '%'; else tick.hidden = true;
      /* come Shopify e come il drawer: spedizione gratuita sul totale dopo gli sconti, sconto automatico sul subtotale prima */
      var draw = function (c) {
        var orig = c.original_total_price != null ? c.original_total_price : c.total_price;
        var base = function (t) { return t.targetType === 'shipping' ? c.total_price : orig; };
        if (!orig) { reward.hidden = true; return; }
        reward.querySelector('[data-sgx-reward-fill]').style.width = Math.min(orig / last, 1) * 100 + '%';
        var nextT = tiers.filter(function (t) { return t.minAmount * 100 > base(t); })[0];
        /* senza percentuale (UpCart senza soglia sconto) la frase finale resterebbe monca: si mostra solo la barra */
        var txt = vals.pct || reward.dataset.tDone.indexOf('{pct}') < 0 ? reward.dataset.tDone : '';
        if (nextT) {
          var tpl = nextT.targetType === 'shipping' ? reward.dataset.tShip : reward.dataset.tDisc;
          txt = tpl.replace('{amount}', money(Math.round(nextT.minAmount * 100) - base(nextT)));
          if (tpl.indexOf('{pct}') > -1 && !vals.pct) txt = '';
        }
        txt = txt.replace('{pct}', vals.pct);
        reward.querySelector('[data-sgx-reward-text]').textContent = txt;
        reward.hidden = false;
      };
      var load = function () {
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { draw(c); })
          .catch(function () {});
      };
      load();
      document.addEventListener('sg:cart-add', function () { setTimeout(load, 300); });
      /* il drawer del tema manda il carrello aggiornato a ogni ridisegno (aggiunte, quantita', rimozioni) */
      document.addEventListener('cart:updated', function (e) {
        var c = e.detail && e.detail.cart;
        if (c && c.items) draw(c);
      });
      if (typeof window.upcartSubscribeCartUpdated === 'function') {
        try { window.upcartSubscribeCartUpdated(function () { load(); }); } catch (x) {}
      }
    });

    syncButtons();
  }

  /* Sezioni collegate alla variante (contenuto bag) */
  document.addEventListener('sg:variant-change', function (e) {
    document.querySelectorAll('[data-sgx-vsec]').forEach(function (box) {
      if (box.dataset.product !== String(e.detail.productId)) return;
      var vid = String(e.detail.variantId);
      /* con clic veloci le risposte possono arrivare in disordine: vale solo l'ultima variante scelta */
      box.dataset.req = vid;
      fetch(box.dataset.url + '?variant=' + vid + '&section_id=' + box.dataset.section)
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          if (box.dataset.req !== vid) return;
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sgx-vsec]');
          if (fresh) box.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    });
  });

  /* Schede (ingredienti): il bottone n mostra il pannello n */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-sgx-tab]');
    if (!tab) return;
    var box = tab.closest('[data-sgx-tabs]');
    if (!box) return;
    var i = parseInt(tab.getAttribute('data-sgx-tab'), 10);
    box.querySelectorAll('[data-sgx-tab]').forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
    box.querySelectorAll('.sgx-ing__panel').forEach(function (p, n) { p.classList.toggle('is-active', n === i); });
  });

  function initAll() { document.querySelectorAll('[data-sgx]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
